import { render, staticRenderFns } from "./CashierHistory.vue?vue&type=template&id=2fe9ed10&scoped=true"
import script from "./CashierHistory.vue?vue&type=script&lang=js"
export * from "./CashierHistory.vue?vue&type=script&lang=js"
import style0 from "./CashierHistory.vue?vue&type=style&index=0&id=2fe9ed10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe9ed10",
  null
  
)

export default component.exports